import $ from "jquery";
import compile from "@bd-utils/handlerbars-helper";
import BD_Component from "@bd-core/bd-component";
import CONFIG from "@bd-core/config";
import {
    getRoomStatus,
    getFinalTeamAnswers,
    getTeamAnswers,
    getHintUsed,
} from "@bd-stores/game-progress";
import {
    maybeUpdateRoomStatus,
    saveFinalRoomAnswers,
    updateRoomAnswer,
} from "@bd-core/firebase-actions";
import IntroVideo from "@bd-utils/intro-video-room";
import OutroVideo from "@bd-utils/outro-video-room";
import Hints from "@bd-utils/hints";
import interact from "interactjs";
import { getRoomAnswerById } from "@bd-stores/game-data";
import CompletionPopup from "@bd-utils/completion-popup";

export class RoomMatchCard extends BD_Component {
    constructor() {
        super();

        this.id = "match_card";
        this.templateID = "match_card-template";
        this.elms = {
            blur: ".app-blur",
            frameItemParent: ".matchCards__frames--item",
            frameItem: ".js-frame-item",
            shardsContainer: ".matchCards__shards--inner",
            shardsSelection: ".js-shards-selection",
            shardsItem: ".js-shards-item",
            shardsBtn: ".js-matchCard-select",
            matchCardFrames: ".js-matchCard-frames",
            matchCardAnswer: ".js-matchCard-answer",
            draggable: ".js-draggable",
            answerInput: ".js-answer-input",
            answerBox: ".answerBox",
            submitBtn: ".js-submit-answer.answer",
            hint: ".hint",
        };

        this._events = this.getEvents();

        /**
         * @type {Array<HTMLAudioElement>}
         */
        this.audios = [];

        /**
         * @type {BD_RoomMatchCards}
         */
        this._data = undefined;

        this.userAnswer = undefined;
        this.selectedShards = 0;
        this.totalShard = 0;

        this.useMiddleState = true;
        this.hints = new Hints();
        this.popupHint = [];
        this.completionPopup = new CompletionPopup();
    }

    /**
     * @returns {Array<BD_ComponentEvent>}
     */
    getEvents() {
        const elms = this.elms;
        return [
            {
                event: "click",
                selector: elms.submitBtn,
                handler: this.onClickedSubmit,
            },
            {
                event: "keydown",
                selector: elms.answerInput,
                handler: this.onAnswerInput,
            },
            {
                event: "keyup",
                selector: elms.answerInput,
                handler: this.onAnswerInputKeyUp,
            },
        ];
    }

    onAnswerInput(e) {
        const elms = this.elms;
        const $answerInput = $(elms.answerInput);
        const answer = $answerInput.val();
        const isEnterKey = e.key === "Enter" || e.keyCode === 13;

        if (isEnterKey) {
            e.preventDefault();
            const hasValue = String(answer).length > 0;
            if (hasValue) {
                $(elms.submitBtn).trigger("click");
            }
        } else {
            $(this.elms.answerBox).removeClass("is-incorrect");
        }
    }

    onAnswerInputKeyUp() {
        const elms = this.elms;
        const $answerInput = $(elms.answerInput);
        const answer = $answerInput.val();
        const hasValue = String(answer).length > 0;
        $(elms.submitBtn).prop("disabled", !hasValue);
    }

    onClickedSubmit() {
        const userAnswer = $(this.elms.answerInput).val().toString().trim();
        if (!userAnswer) return;

        const roomID = this.roomId;
        let roomStatus = "is-status-started";

        let roomAnswer = getRoomAnswerById(roomID);
        roomAnswer = roomAnswer.answers;
        const isCorrect = roomAnswer.includes(userAnswer);
        const state = isCorrect ? "is-correct" : "is-incorrect";
        $(this.elms.answerBox).addClass(state);

        if (isCorrect) {
            roomStatus = "is-status-completed";

            this.outroVideo.startVideo();

            saveFinalRoomAnswers(roomID, userAnswer);
        }

        maybeUpdateRoomStatus(roomID, roomStatus);
    }

    updateUserAnswer(selectedShardId) {
        this.userAnswer = this.userAnswer ? this.userAnswer : [];
        this.userAnswer.push(selectedShardId);

        const totalSelectedShard = this.userAnswer.length;
        const isJarFixed = totalSelectedShard === this.totalShard;

        const roomID = this.roomId;
        const currentPlayerId = CONFIG.user.id;

        let answer = {
            jar: this.userAnswer,
            isCorrect: false,
        };

        if (isJarFixed) {
            answer.isCorrect = true;
            $(this.elms.matchCardFrames).addClass("is-completed");
        }

        updateRoomAnswer(roomID, {
            [currentPlayerId]: answer,
        });
    }

    beforeInit() {
        this.render();
        this.setGameState();
        this.initIntroVideo();
        this.initOutroVideo();
        this.initDraggable();
        this.initHints();
    }

    initDraggable() {
        let closeTimeout = null;

        const overlapValues = {
            1: 0.5,
            2: 0.25,
            3: 0.05,
            4: 0.25,
            5: 0.5,
            6: 0.2,
            7: 0.1,
            8: 0.05,
            9: 0.25,
        };

        for (let i = 1; i <= 9; i++) {
            interact(`.js-dropzone[data-id="${i}"]`).dropzone({
                accept: this.elms.draggable,
                overlap: overlapValues[i],

                ignoreFrom: "",

                ondropactivate: function (event) {
                    event.target.classList.add("drop-active");
                },
                ondragenter: function (event) {
                    var draggableElement = event.relatedTarget;
                    var dropzoneElement = event.target;

                    dropzoneElement.classList.add("drop-target");
                    draggableElement.classList.add("can-drop");
                },
                ondragleave: function (event) {
                    event.target.classList.remove("drop-target");
                    event.relatedTarget.classList.remove("can-drop");
                },
                ondrop: function (event) {
                    const elms = this.elms;
                    const droppedShard = event.relatedTarget;
                    const dropZone = event.target;

                    const shardId = parseInt(
                        droppedShard.getAttribute("data-id"),
                    );
                    const targetShardId = parseInt(
                        dropZone.getAttribute("data-id"),
                    );

                    const $matchCardAnswer = $(elms.matchCardAnswer);
                    const $matchCardFrameParent = $(elms.frameItemParent);
                    const $img = $(`.js-img-${shardId}`);

                    $matchCardAnswer.removeClass(function (_, className) {
                        return (
                            className.match(
                                /is-correct|is-incorrect|img-\d+/g,
                            ) || []
                        ).join(" ");
                    });
                    const isCorrect = shardId === targetShardId;
                    const state = isCorrect ? "is-correct" : "is-incorrect";
                    $matchCardFrameParent.removeClass(
                        "is-selected is-correct is-incorrect",
                    );
                    $matchCardAnswer.addClass(
                        `is-open img-${shardId} ${state}`,
                    );

                    if (isCorrect) {
                        $(droppedShard)
                            .siblings(elms.shardsItem)
                            .addClass("is-completed")
                            .prop("disabled", true);
                        $(dropZone).addClass("is-completed");
                        $(droppedShard).hide();

                        this.updateUserAnswer(shardId);
                        $img.addClass("is-filled");

                        interact(dropZone).unset();
                    }

                    if (closeTimeout) {
                        clearTimeout(closeTimeout);
                    }

                    closeTimeout = setTimeout(() => {
                        $matchCardAnswer.removeClass("is-open");
                        closeTimeout = null;
                    }, 2000);
                }.bind(this),
                ondropdeactivate: function (event) {
                    event.target.classList.remove("drop-active");
                    event.target.classList.remove("drop-target");
                },
            });
        }

        interact(this.elms.draggable).draggable({
            modifiers: [
                interact.modifiers.restrict({
                    restriction: ".matchCards",
                    endOnly: true,
                }),
            ],
            autoScroll: true,
            listeners: {
                start: function (event) {
                    if (closeTimeout) {
                        clearTimeout(closeTimeout);
                        closeTimeout = null;
                    }
                    $(this.elms.matchCardAnswer).removeClass("is-open");
                    event.target.classList.add("is-dragging");
                    event.target.style.cursor = "grabbing";

                    // Calculate the offset from the click point to center the element on cursor
                    // var rect = event.target.getBoundingClientRect();
                    // var clickX = event.clientX - rect.left;
                    // var clickY = event.clientY - rect.top;
                    // event.target.setAttribute("data-offset-x", clickX);
                    // event.target.setAttribute("data-offset-y", clickY);
                }.bind(this),
                move: dragMoveListener,
                end(event) {
                    event.target.classList.remove("is-dragging");
                    event.target.style.cursor = "grab";

                    if (!event.target.classList.contains("is-completed")) {
                        event.target.style.transform = "translate(0px, 0px)";
                        event.target.setAttribute("data-x", 0);
                        event.target.setAttribute("data-y", 0);
                    }
                },
            },
        });

        interact(".js-draggable").styleCursor(false);

        function dragMoveListener(event) {
            var target = event.target;

            var x = (parseFloat(target.getAttribute("data-x")) || 0) + event.dx;
            var y = (parseFloat(target.getAttribute("data-y")) || 0) + event.dy;

            var centerX = parseFloat(target.getAttribute("data-center-x")) || 0;
            var centerY = parseFloat(target.getAttribute("data-center-y")) || 0;

            target.style.transform =
                "translate(" + (x - centerX) + "px, " + (y - centerY) + "px)";

            target.setAttribute("data-x", x);
            target.setAttribute("data-y", y);
        }
    }

    getModifiedData() {
        const modified = { ...this._data };
        const hotspots = this._data.hotspots;

        // if `default_image` is not set in the admin, we will use this fallback image
        const defaultImageBg = `${CONFIG.themeURL}/assets/images/matchcards-new.png`;

        const _image_bg = this._data.image_bg
            ? this._data.image_bg
            : defaultImageBg;

        const hintHotspots = hotspots.filter(
            (hotspot) => hotspot["hotspot_type"] === "hint",
        );

        const hotspotCount = hintHotspots.length;
        const defaultValue = "50%";
        const newHints = this._data.hints.map((hint, i) => {
            this.popupHint.push({ ...hint });

            const font_fam = hint.hint_font_family.split("|");
            const font_name = font_fam[0];
            const font_category = font_fam[1];

            return {
                ...hint,
                font_family: `"${font_name}", ${font_category}`,
                has_image: hint.image,
                position_top:
                    hotspotCount > 0 && hintHotspots[i]
                        ? hintHotspots[i].position_top
                        : defaultValue,
                position_left:
                    hotspotCount > 0 && hintHotspots[i]
                        ? hintHotspots[i].position_left
                        : defaultValue,
            };
        });

        const modifiedData = {
            ...modified,
            hints: newHints,
            hintProps: CONFIG.game.hintProp,
            image_bg: _image_bg,
        };

        return modifiedData;
    }

    render() {
        const modifiedData = this.getModifiedData();

        const htmlTemplate = $("#" + this.templateID).html();
        const html = compile(htmlTemplate, modifiedData);

        $(".app").html(html);

        this.randomizeShards();
        this.totalShard = $(this.elms.frameItemParent).length;
    }

    randomizeShards() {
        const $shardsContainer = $(this.elms.shardsContainer);
        const $shards = $shardsContainer.children().toArray();

        for (let i = $shards.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [$shards[i], $shards[j]] = [$shards[j], $shards[i]];
        }

        $shards.forEach((shard) => $shardsContainer.append(shard));
    }

    setGameState() {
        const roomId = this.roomId;

        const userId = CONFIG.user.id;
        const thisRoomStatus = getRoomStatus(roomId);
        const finalRoomAnswers = getFinalTeamAnswers(roomId);
        const isHintUsed = getHintUsed(roomId);
        const teamAnswers = getTeamAnswers(roomId);
        this.userAnswer = Array.isArray(teamAnswers[userId]?.jar)
            ? [...teamAnswers[userId].jar]
            : [];
        const elms = this.elms;

        const possibleStatuses = [
            "is-status-open",
            "is-status-started",
            "is-status-completed",
        ];

        if (thisRoomStatus) {
            const $status = $(".js-room-status");
            $status.removeClass(possibleStatuses);
            $status.addClass(thisRoomStatus);
        }

        if (teamAnswers && Object.keys(teamAnswers).length > 0) {
            const answer = teamAnswers[userId];

            const isJarFixed = answer.jar.length === this.totalShard;
            if (isJarFixed) {
                $(elms.matchCardFrames).addClass("is-completed");
                $(elms.shardsItem)
                    .addClass("is-completed")
                    .prop("disabled", true);
                $(elms.shardsItem).siblings(elms.draggable).hide();
                $(elms.answerInput)
                    .removeClass("is-locked")
                    .prop("disabled", false);
            } else {
                answer.jar.forEach((shardId) => {
                    // set is-filled for each answer
                    const $img = $(`.js-img-${shardId}`);
                    $img.addClass("is-filled");

                    // set is-completed and disabled for shard selection
                    const $shardsItem = $(
                        `.js-shards-item[data-id="${shardId}"]`,
                    );
                    $shardsItem.addClass("is-completed").prop("disabled", true);
                    $shardsItem.siblings(elms.draggable).hide();
                });
            }
        }

        if (finalRoomAnswers) {
            if (thisRoomStatus == "is-status-completed") {
                this.completionPopup.show(roomId, false, finalRoomAnswers);

                $(elms.answerInput)
                    .addClass("is-locked")
                    .prop("disabled", true)
                    .html(`${finalRoomAnswers}`);
                $(elms.answerBox).addClass("is-completed");
                $(".js-repair-challenge").addClass("is-completed");
                $(elms.submitBtn).parent().parent().addClass("is-completed");
                $(".app__page").addClass("is-room-completed");
            }
        }

        if (isHintUsed) {
            $(".hint").addClass("is-used");
        } else {
            $(".hint").removeClass("is-used");
        }
    }

    initIntroVideo() {
        this.introVideo = new IntroVideo();
        this.introVideo.initForRoom("match-card", "intro-video-match-card");
    }

    initOutroVideo() {
        this.outroVideo = new OutroVideo();
        this.outroVideo.initForRoom("match-card", "outro-video-match-card");
    }

    initHints() {
        this.hints.init(this.roomId, this.popupHint);
    }

    beforeDestroy() {
        // Remove all interact.js drag and drop listeners for this room instance
        for (let i = 1; i <= 9; i++) {
            interact(`.js-dropzone[data-id="${i}"]`).unset();
        }

        if (this.elms && this.elms.draggable) {
            $(this.elms.draggable).each(function () {
                interact(this).unset();
            });
        }

        if (this.introVideo) {
            this.introVideo.cleanup();
            this.introVideo = null;
        }

        if (this.outroVideo) {
            this.outroVideo.cleanup();
            this.outroVideo = null;
        }
    }
}
